import styled from "@emotion/styled";
import React from "react";

const StyledTextContainer = styled.div`
  margin: var(--4xl) auto 0;
  padding-bottom: var(--4xl);
  border-bottom: 1px solid var(--divider);

  @media (max-width: 1060px) {
    margin-top: var(--3xl);
  }

  .row > div {
    max-width: 90%;
    margin: auto;
  }

  header {
    text-align: center;
    margin-bottom: var(--xl);
  }

  h1 {
    text-align: center;
    margin-bottom: var(--lg);
    font-size: var(--huge);

    @media (max-width: 1060px) {
      font-size: var(--xx-large);
    }
  }

  h2 {
    font-size: var(--large);
  }

  h3 {
    font-size: var(--medium);
  }

  h4 {
    font-size: var(--normal);
  }

  h5 {
    font-size: var(--base);
  }
  h6 {
    font-size: var(--small);
  }

  h2,
  h3 {
    margin: var(--2xl) 0 var(--sm);
  }

  h4,
  h5,
  h6 {
    margin: var(--xl) 0 var(--xsm);
  }

  p + p {
    margin-top: var(--lg);
  }

  section {
    max-width: 90%;
    text-align: left;
    margin-top: 0%;
  }

  a {
    color: var(--orange);
    text-decoration: underline;

    &:hover,
    &:focus {
      color: var(--white);
      text-decoration: none;
    }
  }

  ol,
  ul {
    list-style-position: inside;
    margin: var(--md) 0;

    & > * {
      &:not(:first-child) {
        margin-top: var(--xs);
      }
    }
  }
`;

export const TextContainer = ({ children }) => (
  <StyledTextContainer>
    <div className="row">
      <div>{children}</div>
    </div>
  </StyledTextContainer>
);
